import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import has from 'lodash-es/has';

@Injectable()
export class SharedDataService {

  private _sharedDataSubjects: any = {};

  constructor() { }

  /**
   * @desc Get Value to subscribe on
   *
   * @param {string} dataKey
   * @return {any}
   */
  getValue(dataKey) {
    this._initSharedDataSubjects(dataKey);

    return this._sharedDataSubjects[dataKey].asObservable();
  }

  /**
   * @desc Update value for current key
   *
   * @param {string} dataKey
   * @param {any} dataValue
   */
  updateValue(dataKey: string, dataValue: any) {
    this._initSharedDataSubjects(dataKey);
    this._sharedDataSubjects[dataKey].next(dataValue);
  }

  /**
   * @desc Initialize data subjects if not initialized already
   * @param {string} dataKey
   */
  private _initSharedDataSubjects(dataKey: string) {
    if (!has(this._sharedDataSubjects, dataKey)) {
      this._sharedDataSubjects[dataKey] = new BehaviorSubject<any>(undefined);
    }
  }
}
